export const DRAWER_INITIAL_WIDTHS = {
  normal: 400,
  wide: 620,
};

export const MAX_DRAWER_WIDTH = 1000;
